import { motion } from "framer-motion";

const accent = {
  border: "rgba(0,255,136,0.28)",
  glow: "0 0 44px rgba(0,255,136,0.22)",
  text: "#00ff88",
};

export function AudioConsent({ onAllow, onDeny }) {

  return (
    <motion.div
      className="
        fixed inset-0 z-[100]
        flex items-center justify-center
        bg-black/80
        backdrop-blur-md
      "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >

        <motion.div
          className="
            glass
            relative
            w-[90%]
            max-w-xl
            overflow-hidden
            border
            px-6
            py-5
          "
          style={{
            borderColor: accent.border,
            boxShadow: accent.glow
          }}
        >
          <h2
            className="
              font-display
              text-4xl
              font-black
              uppercase
              tracking-tight
              text-white
            "
          >
            <div
              className="
                text-center
              "
            >
              Maverick's Back!
              <br />
              😎  With Merch & Music!  😎
            </div>
          </h2>

          <div
            className="
              mt-2
              h-px
              w-full
              bg-gradient-to-r
              from-emerald-400/60
              via-emerald-400/20
              to-transparent
            "
          />

            <p
              className="
                mt-3
                text-center
                font-mono
                text-sm
                leading-relaxed
                text-white/60
              "
            >
              Background audio is available for this experience.
            </p>

          <div
            className="
              mt-3
              rounded-lg
              border
              border-emerald-400/15
              bg-emerald-400/[0.03]
              px-4
              py-3
            "
          >
            <p
              className="
                text-center
                font-mono
                text-xs
                leading-relaxed
                text-emerald-200/80
              "
            >
              Browse the{' '}
              <span
                className="
                  font-bold
                  text-emerald-300
                  drop-shadow-[0_0_8px_rgba(0,255,136,0.45)]
                "
              >
                MERCH
              </span>
              .
              <br />
              Safe payments powered by{' '}
              <span
                className="
                  font-bold
                  text-white
                "
              >
                STRIPE
              </span>
              .
            </p>
          </div>

          <div
            className="
              mt-5
              flex
              gap-3
            "
          >
            <button
              onClick={onAllow}
              className="
                flex-1
                border
                border-emerald-400/40
                bg-emerald-400/[0.04]
                px-5
                py-3
                font-mono
                text-xs
                font-bold
                uppercase
                tracking-wider
                text-emerald-300
                shadow-[0_0_18px_rgba(0,255,136,0.06)]
                transition-all
                duration-300
                hover:border-emerald-300
                hover:bg-emerald-400/10
                hover:text-emerald-200
                hover:shadow-[0_0_24px_rgba(0,255,136,0.15)]
              "
            >
              Enable Audio
            </button>

            <button
              onClick={onDeny}
              className="
                flex-1
                border
                border-white/10
                bg-white/[0.02]
                px-5
                py-3
                font-mono
                text-xs
                font-bold
                uppercase
                tracking-wider
                text-white/45
                transition-all
                duration-300
                hover:border-white/25
                hover:bg-white/5
                hover:text-white/70
              "
            >
              Silent Mode
            </button>
          </div>

          <div
            className="
              mt-3
              text-center
              font-mono
              text-[9px]
              uppercase
              tracking-[0.25em]
              text-white/20
            "
          >
            Choose your experience
          </div>
        </motion.div>

    </motion.div>
  );
}